import { create } from 'zustand';
import userService from '../services/userService';

const useAuthStore = create((set) => ({
  user: null,
  isLoading: true,
  error: null,

  fetchUser: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await userService.getMe(); // API trả về thông tin người dùng
      set({ user: response.data, isLoading: false });
    } catch (err) {
      set({ user: null, isLoading: false, error: err.message });
    }
  },

  refetchUser: async () => {
    // Call fetchUser directly
    const { fetchUser } = useAuthStore.getState();
    await fetchUser();
  },

  clearUser: () => set({ user: null, isLoading: false, error: null }),
  logout: () => {
    set({ user: null });
    localStorage.removeItem('token');
  },
}));


export default useAuthStore;
